import React from "react";
import Error from "./Error";
import PropTypes from "prop-types";

/**
 * This component catches errors thrown by any of the child tree components,
 * It renders when an error is thrown inside of: component life cycle method,
 * component constructor, render method.
 */
export class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error, info) {
        this.setError(true, error, info);
    }

    render() {
        if (this.state.hasError) {
            return <Error />;
        } else {
            return this.props.children;
        }
    }

    setError(errorStatus, error, info) {
        this.setState({ hasError: errorStatus });
        this.props.logError("Component Render Error ", error, info);
    }
}

ErrorBoundary.propTypes = {
    logError: PropTypes.func
};

export default ErrorBoundary;